import { Dispatch, SetStateAction } from "react";
import { ByUnit, CostCenterData } from "~/application/types/entities/CustomerBI.type";
import { Box } from "~/components/Box";
import { Card } from "~/components/Card";
import { Flex } from "~/components/Flex";
import { Text } from "~/components/Text";
import { H4 } from "~/components/Typography";
import { asCurrency } from "~/utils/mask.utils";
import { OnSelectMultiValuesProps } from "../../types";
import { MultiValue } from "../../DashboardCustomerPage";

type CostCenterResumeProps = {
  unitSummary?: ByUnit[];
  selectedUnit?: string[];
  selectedMultiValues: MultiValue;
  onSelectMultiValues: ({ value, field }: OnSelectMultiValuesProps) => void;
};

export function UnitList({
  unitSummary,
  selectedUnit,
  selectedMultiValues,
  onSelectMultiValues,
}: CostCenterResumeProps) {
  return (
    <Card css={{ overflow: "hidden", height: "600px" }}>
      <Box css={{ p: "$5" }}>
        <H4>Valor por unidade de negócio</H4>
      </Box>
      <Box css={{ maxHeight: "fit-content", overflow: "auto" }}>
        {unitSummary?.map((unit) => (
          <Flex
            key={unit.name}
            onClick={() => onSelectMultiValues({ value: unit.uuid, field: "units" })}
            justify="between"
            css={{
              p: "$4",
              borderRadius: "$2",
              alignItems: "center",
              cursor: "pointer",
              backgroundColor: selectedMultiValues.units?.includes(unit.uuid)
                ? "$primary-light"
                : "transparent",
              borderBottom: "1px solid $neutrals-lightest",
              "&:hover": {
                backgroundColor: "$neutrals-lightest",
              },
            }}
          >
            <Flex align="center" gap="4">
              <Flex gap="1" direction="column" justify="center">
                <Text fw="600">{unit.name}</Text>
                <Text css={{ fontSize: "$sm", color: "$neutrals-darkest" }}>
                  Último pedido: {unit.lastOrderDate}
                </Text>
              </Flex>
            </Flex>
            <Text fw="700" css={{ color: "$success-base" }}>
              {asCurrency(unit.value)}
            </Text>
          </Flex>
        ))}
      </Box>
    </Card>
  );
}
